import { render, staticRenderFns } from "./DetalleSolicitudAMEX.vue?vue&type=template&id=8d3bab90&scoped=true&"
import script from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSolicitudAMEX.vue?vue&type=style&index=0&id=8d3bab90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3bab90",
  null
  
)

component.options.__file = "DetalleSolicitudAMEX.vue"
export default component.exports